import { SET_READY } from './constants'

const initialState = false

export default function reducer(state = initialState, action) {
    switch (action.type) {
        // Backend ready state changed
        case SET_READY: {
            return action.payload
        }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/ready/reducer.js